
      if (!isRetiredClockworkHost) {
        // Static imports would initialize the app on retired hosts before this guard.
        void import("/src/index.tsx");
      }
    